import React, { createContext, useContext, useMemo, useState } from 'react'
import { MuiThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import MuiThemeProviderOld from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import { createAppTheme } from '../theme'

export const THEME_STORAGE_KEY = 'blickm-color-mode'
const ColorModeContext = createContext()

function readPreference() {
  try {
    const value = window.localStorage.getItem(THEME_STORAGE_KEY)
    return value === 'light' || value === 'dark' ? value : null
  } catch {
    return null
  }
}

export default function ThemeProvider({ children }) {
  const [preference, setPreference] = useState(readPreference)
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true })
  const mode = preference || (prefersDark ? 'dark' : 'light')
  const theme = useMemo(() => createAppTheme(mode), [mode])
  // The multi-select editor still uses Material UI v0's theme format.
  const legacyTheme = useMemo(() => getMuiTheme({
    fontFamily: theme.typography.fontFamily,
    palette: {
      primary1Color: theme.palette.primary.main,
      accent1Color: theme.palette.primary.main,
      textColor: theme.palette.text.primary,
      secondaryTextColor: theme.palette.text.secondary,
      alternateTextColor: theme.palette.background.default,
      canvasColor: theme.palette.background.paper,
      borderColor: theme.palette.divider,
      disabledColor: theme.palette.text.disabled,
    },
  }), [theme])

  const colorMode = useMemo(() => ({
    mode,
    toggleMode: () => {
      const nextMode = mode === 'dark' ? 'light' : 'dark'
      setPreference(nextMode)
      try {
        window.localStorage.setItem(THEME_STORAGE_KEY, nextMode)
      } catch {
        // The toggle still works when browser storage is unavailable.
      }
    },
  }), [mode])

  return (
    <ColorModeContext.Provider value={colorMode}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <MuiThemeProviderOld muiTheme={legacyTheme}>
          {children}
        </MuiThemeProviderOld>
      </MuiThemeProvider>
    </ColorModeContext.Provider>
  )
}

export const useColorMode = () => useContext(ColorModeContext)
